import { Box, IconButton, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";


pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;


type PdfViewerProps = {
    fileUrl: string;
    locationHint?: string;
};

export const PdfViewer = ({ fileUrl, locationHint }: PdfViewerProps) => {
    const [numPages, setNumPages] = useState<number | null>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);

    const pageRefs = useRef<(HTMLDivElement | null)[]>([]);

    const handleLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    // wyciągamy numer strony z tekstu od AI, jeśli jest
    useEffect(() => {
        if (!locationHint) return;

        const match = locationHint.match(/page\s+(\d+)/i);
        if (!match) return;

        const page = parseInt(match[1], 10);
        if (!Number.isNaN(page)) {
            setCurrentPage(page);
        }
    }, [locationHint]);

    useEffect(() => {
        if (!numPages) return;
        const idx = currentPage - 1;
        const el = pageRefs.current[idx];
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [currentPage, numPages]);

    const goPrev = () => {
        setCurrentPage((p) => (p > 1 ? p - 1 : 1));
    };

    const goNext = () => {
        if (!numPages) return;
        setCurrentPage((p) => (p < numPages ? p + 1 : numPages));
    };

    return (
        <Box
            sx={{
                border: "1px solid #ccc",
                height: "65vh",
                overflow: "auto",
                p: 1,

            }}
        >
            <Box
                sx={(theme) => ({
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 1,
                    py: 0.5,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                })}
            >

                <Box>
                    <IconButton
                        size="small"
                        onClick={goPrev}
                        disabled={currentPage <= 1}
                    >
                        <ArrowBackIosNewIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={goNext}
                        disabled={!numPages || currentPage >= numPages}
                    >
                        <ArrowForwardIosIcon fontSize="inherit" />
                    </IconButton>
                </Box>

                <Typography variant="caption">
                    Page {currentPage} {numPages ? `of ${numPages}` : ""}
                </Typography>
            </Box>
            <Box
                sx={{
                    flex: 1,
                    overflow: "auto",
                    p: 1,
                }}
            >
                <Document file={fileUrl} onLoadSuccess={handleLoadSuccess}>
                    {Array.from(new Array(numPages || 0), (_, index) => (
                        <div
                            key={index}
                            ref={(el) => {
                                pageRefs.current[index] = el;
                            }}
                            style={{ marginBottom: 16 }}
                        >
                            <Page
                                pageNumber={index + 1}
                                width={800}
                                renderAnnotationLayer={true}
                                renderTextLayer={true}
                            />
                        </div>
                    ))}
                </Document>
            </Box>
        </Box >
    );
};
